(function() {
    const GestioneDocumentiService = function() {};

    GestioneDocumentiService.$inject = [];

    angular
        .module('cbl.mitomanager.wa')
        .service('MitomGestioneDocumentiService', GestioneDocumentiService);
})();